import type { ReactNode } from 'react';

export const symbol_laptop_windows: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M30-160q-12.75 0-21.37-8.68Q0-177.35 0-190.18 0-203 8.63-211.5 17.25-220 30-220h111v-42q-24 0-42-18t-18-42v-458q0-24 18-42t42-18h678q24 0 42 18t18 42v458q0 24-18 42t-42 18v42h111q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H30Zm111-162h678v-458H141v458Zm0 0v-458 458Z"
		/>
	</svg>
);
